import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { usePortalsAuth } from '../hooks/usePortalsAuth';
import { PortalsAccessDenied } from './PortalsAccessDenied';
import { getPortalEnv } from '../utils/metadata';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function DefaultAuthLoading() {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    justifyContent: "center",
    minBlockSize: "100%",
    padding: "800",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {})
  });
}
const DEBUG_PARAM = 'portalsAuthState';
const DEBUG_STATES = ['loading', 'accessDenied', 'authenticated'];
function getDebugAuthState() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  if (getPortalEnv() === 'prod') {
    return undefined;
  }
  const value = new URLSearchParams(window.location.search).get(DEBUG_PARAM);
  return DEBUG_STATES.find(state => state === value);
}
export function PortalsAuthGuard({
  children,
  loadingFallback = /*#__PURE__*/_jsx(DefaultAuthLoading, {}),
  redirectUrl
}) {
  const debugState = getDebugAuthState();
  if (debugState !== undefined) {
    if (debugState === 'loading') {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: loadingFallback
      });
    }
    if (debugState === 'accessDenied') {
      return /*#__PURE__*/_jsx(PortalsAccessDenied, {});
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(PortalsAuthGuardImpl, {
    loadingFallback: loadingFallback,
    redirectUrl: redirectUrl,
    children: children
  });
}
function PortalsAuthGuardImpl({
  children,
  loadingFallback,
  redirectUrl
}) {
  const {
    isLoading,
    isAccessDenied,
    user
  } = usePortalsAuth({
    redirectUrl
  });
  if (isLoading) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: loadingFallback
    });
  }
  if (isAccessDenied) {
    return /*#__PURE__*/_jsx(PortalsAccessDenied, {});
  }
  if (!user) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: loadingFallback
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}